<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <error-msg-component v-if="messagesPopup"
                          :messages="messagesPopup"
                          :error="messagesPopup.length > 0"
                          :title="'general.problemOccurred'"
                          :withEmplyFields="true"/>
      <section class="has-text-centered">
        <b-icon type="is-danger" icon="alert-circle-outline" class="icon-modal"></b-icon>
        <p class="is-size-5 has-text-weight-bold">
          {{ messHeader }}
        </p>
        <div v-for="(message, $index) in messages" :key="$index">
          <router-link-blank v-if="message.isLink"
                             :to="{ name: message.routeName, params: message.params }"
                             :message="message.libelle">
          </router-link-blank>
          <div v-else>
            {{ message.libelle }}
          </div>
        </div>
      </section>
      <br>
      <main>
        <div class="has-text-centered">
          <button class="button is-primary has-text-centered button-modal"
                  @click="$parent.close"   >
            {{ $t('general.button.ok') }}
          </button>
        </div>
      </main>
      <footer class="subtitle modal-complement has-text-centered" v-if="messFooter">
        <p>
          {{ (messFooter) }}
        </p>
      </footer>
    </div>
  </div>
</template>

<script>
import errorMsgComponent from '@/components/general/errorMsgComponent';
import routerLinkBlank from '@/components/general/routerLinkBlank';

export default {
  name: 'popUpPrevention',
  props: {
    messages: {
      type: Array,
      required: false,
    },
    messagesPopup: Array,
    messHeader: String,
    messFooter: String,
  },
  components: {
    errorMsgComponent,
    routerLinkBlank,
  },
  methods: {
  },
};
</script>

<style scoped>

</style>
